// @flow strict

import styled from 'styled-components';

export const RawStyledTabGroupTabs = styled.ul`
  display: flex;
`;

export const StyledTabGroupTabs = RawStyledTabGroupTabs;
